import { createContext, useContext } from "react";
import type { AuthMode } from "../config";

export type AuthStatus = "loading" | "signed_out" | "signed_in";

export type AuthUser = {
  name: string;
  email: string;
};

export type AuthContextValue = {
  mode: AuthMode;
  status: AuthStatus;
  user: AuthUser | null;
  error: string | null;
  signIn: () => void;
  signOut: () => void;
  // Token opaco enviado como Bearer à API. Nunca registrar em logs.
  getAccessToken: () => Promise<string>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth precisa estar dentro de um AuthProvider.");
  return value;
}
